import { useState, useEffect } from 'react';

const useCurrentLocation = () => {
    const [currentLocation, setLocation] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!navigator.geolocation) {
            setError('Geolocation is not supported by your browser.');
            return;
        }

        navigator.geolocation.getCurrentPosition((position) => {
            setLocation({
                lat: position.coords.latitude,
                lng: position.coords.longitude
            });
        }, () => {
            setError('Unable to retrieve your location');
        });
    }, []);

    return { currentLocation, error };
};

export default useCurrentLocation;
